import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { IssueItem } from "@ServerTypes/issues/issues.schema";

type EditIssueState = IssueItem | null;

const editIssuesSlice = createSlice({
  name: "editIssues",
  initialState: null as EditIssueState,
  reducers: {
    setEditIssuesData: (_state, action: PayloadAction<EditIssueState>) => action.payload,
  },
});

export const { setEditIssuesData } = editIssuesSlice.actions;

export const editIssues = editIssuesSlice.reducer;

export default editIssuesSlice.reducer;
